import React, { useEffect, useState } from "react";
import { Row, Col} from "reactstrap";
import { Link, useHistory } from "react-router-dom";

// Formik 
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { loginSuccess, setLoading } from "../../store/actions";
import 'toastr/build/toastr.min.css';


// import images
import profile from "../../assets/images/Bastet_logo.png";
import { UserService } from "../../services/userService";
import { removeHistory } from '../../store/auth/cart/actions'

import toastr from 'toastr'


const initialValues = {
  nombres: "",
  apellidos: "",
  fechaNacimiento: "",
  idGenero: "1", // String porque el esquema lo valida como string
  tipoIdentificacion: "CC",
  numeroDocumento: "",
  telefono: "",
  email: "",
  clave: "",
  confirmaClave: "",
  clienteCorp: true,
  nit: ""
};

const formValidation = Yup.object().shape({
  nombres: Yup.string().required("Requerido"),
  apellidos: Yup.string().required("Requerido"),
  fechaNacimiento: Yup.string().required("Requerido"),
  idGenero: Yup.string().required("Requerido"),
  tipoIdentificacion: Yup.string().required("Requerido"),
  numeroDocumento: Yup.string().required("Requerido"),
  telefono: Yup.string().required("Requerido"),
  email: Yup.string().email("Correo inválido").required("Requerido"),
  clave: Yup.string()
    .required("Requerido")
    .min(8, "Mínimo 8 caracteres")
    .matches(
      /^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)(?=.*[A-Z]+.*)[0-9a-zA-Z]{8,}$/,
      "Debe contener mínimo un número y una letra mayúscula"
    ),
  confirmaClave: Yup.string().oneOf(
    [Yup.ref("clave"), null],
    "Las contraseñas no coinciden"
  )
});

export default function Register(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const userService = new UserService();
  const [clientCorpCheck, setClientCorpCheck] = useState(false);
  const historyRedirection = useSelector((state) => state.cart.history);

const onSubmit = async (values) => {
  const payload = {
    ...values,
    id: 0,
    uid: crypto.randomUUID(),
    nivel: "BASICO",
    ipOrigen: "127.0.0.1", // Esto se puede ajustar desde el backend si hace falta
    temporal: "",
    deviceToken: "",
    perfil: 1,
    aceptoTyC: true,
    autorizoTDP: true,
    nombrePerfil: "Usuario",
    autorizadoClienteCorp: false,
    totalPuntos: 0,
    dateRegister: new Date().toISOString(),
    fechaNacimiento: new Date(values.fechaNacimiento).toISOString(),
    idGenero: parseInt(values.idGenero),
    clienteCorp: clientCorpCheck
  };

dispatch(setLoading(true));

try {
  console.log("Payload a enviar:", payload);
  const user = await userService.addPerson(payload);

  if (user) {
    user.new = true;
    toastr.success("Registro exitoso, su información ha sido creada con éxito");
    successLogIn(user);
  }

} catch (error) {
  let mensaje = "Error en el registro. Verifica los datos.";

  // Error devuelto por el backend con mensaje específico
  if (error.response?.data?.mensaje) {
    mensaje = error.response.data.mensaje;
  }
  // Error lanzado manualmente desde ApiBase o similar
  else if (error.message) {
    mensaje = error.message;
  }

  toastr.error(mensaje);
} finally {
  dispatch(setLoading(false)); // Apagar loading siempre
}

};


  const successLogIn = (user) => {
    dispatch(loginSuccess(user));
    if (historyRedirection) {
      history.push(historyRedirection);
      dispatch(removeHistory());
      return;
    }
    history.push("home");
  };

  useEffect(() => {
    console.log("Cliente Corporativo:", clientCorpCheck);
  }, [clientCorpCheck]);

  return (
    <React.Fragment>
      <div className="account-pages">
        <div className="col-12 d-flex justify-content-center mt-4">
          <img src={profile} alt="Logo" style={{ maxWidth: "150px", height: "auto" }} />
        </div>
      <div className="row">
        
        <div className="col-md-3 mt-4">
          {/* <img src={imagen} alt="" className="img-fluid" /> */}
        </div>
        
        <div className="col-md-9">
          

          <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={formValidation}>
            <Form className="form-horizontal m-3" >


              {/* <div className="input-group mb-3">
                <span className="input-group-text" id="inputGroup-sizing-default">Default</span>
                <Field type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default"/>
              </div> */}

              <Row form>
                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="nombres" className="control-label">Nombres</label>
                    <Field name="nombres" id="nombres" className="form-control" placeholder="Nombres*" type="text" required />
                    <ErrorMessage name="nombres" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="apellidos" className="control-label">Apellidos</label>
                    <Field name="apellidos" id="apellidos" type="text" className="form-control" required placeholder="Apellidos*" />
                    <ErrorMessage name="apellidos" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>
              </Row>

              <Row form>
                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="fechaNacimiento" className="control-label">Fecha de nacimiento</label>
                    <Field name="fechaNacimiento" id="fechaNacimiento" type="date" className="form-control" required placeholder="Apellidos*" />
                    <ErrorMessage name="fechaNacimiento" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="idGenero" className="control-label">Genero</label>
                    <Field as="select" className="form-control" name="idGenero" id="idGenero">
                      <option value="0">Femenino</option>
                      <option value="1">Masculino</option>
                    </Field>
                    <ErrorMessage name="idGenero" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>
              </Row>

              <Row form>
                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="tipoIdentificacion" className="control-label">Tipo de identificación</label>
                    <Field as="select" className="form-control" name="tipoIdentificacion" id="tipoIdentificacion" required>
                      <option value="CC">Cédula de ciudadanía</option>
                      <option value="CE">Cédula de Extranjería</option>
                    </Field>
                    <ErrorMessage name="tipoIdentificacion" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="numeroDocumento" className="control-label">Numero de documento</label>
                    <Field name="numeroDocumento" id="numeroDocumento" className="form-control" type="text" required placeholder="" />
                    <ErrorMessage name="numeroDocumento" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>
              </Row>

              <Row form>
                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="telefono" className="control-label">Teléfono</label>
                    <Field name="telefono" id="telefono" type="text" className="form-control" required placeholder="" />
                    <ErrorMessage name="telefono" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="email" className="control-label">Email</label>
                    <Field name="email" id="email" type="email" className="form-control" required />
                    <ErrorMessage name="email" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>
              </Row>

              <Row form>
                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="clave" className="control-label">Clave</label>
                    <Field name="clave" id="clave" type="password" className="form-control" required placeholder="" />
                    <ErrorMessage name="clave" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="form-group">
                    <label htmlFor="confirmaClave" className="control-label">Confirmar clave</label>
                    <Field name="confirmaClave" id="confirmaClave" type="password" className="form-control" required placeholder="" />
                    <ErrorMessage name="confirmaClave" >{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  </div>
                </Col>
              </Row>



              <div className="col-md-9">
                <p className="mb-0" style={{color: "gray"}}>
                  Al hacer clic en Registrarse, acepta los{" "}
                  <a href="https://fanerodiag.blob.core.windows.net/tiendas/Productos_Tienda5/Producto_TÉRMINOS Y CONDICIONES ANDIMAT26132338937.pdf" style={{ color: "black" }}>
                    Términos y condiciones<br></br>
                  </a>{" "} y el {" "}
                  <a href="https://fanerodiag.blob.core.windows.net/tiendas/Productos_Tienda5/Producto_POLITICA DE TRATAMIENTO DE DATOS PERSONALES ANDIMAT26132138793.pdf" className="text" style={{ color: "black" }}>
                    Tramiento de Datos Personales
                </a> de  BASTET - TIENDA DERMATOLOGICA.
              </p>
                <div className="col-md-6 offset-md-2 mt-3">
                  <input className="boton3-fanero btn-block waves-effect waves-light" type="submit" value="Registrarse" />
                </div>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <div className="container-fluid">

        <div className="mt-3 text-center">
          <p style={{ color: "gray" }}>
            Tienes una cuenta?{" "}
            <Link
              to="/login"
              className="font-weight-medium"
            >
              {" "}
                    Inicia sesión
                  </Link>{" "}
          </p>
        </div>
      </div>
      </div>



    </React.Fragment >
  );
}